import { ClaimFlowType } from 'types';

import useCreateLandingPageHook, {
  ClaimType,
} from 'components/SubPages/Landing/useCreateLandingPageHook';

import { useUserContext } from 'hooks/useUserContext';

import {
  trackCTATapped,
  trackLandingPageViewed,
} from 'utils/segment/trackingEvents';

type UseReceiveFromAnyoneLandingApi = {
  onCtaClickDebit: () => void;
  onCtaClickChime: () => void;
};

const useReceiveFromAnyoneLandingPage = (): UseReceiveFromAnyoneLandingApi => {
  const [userData] = useUserContext();
  const { publicId, senderId, amount } = userData;

  const fireLandingPageViewedEvents = () => {
    trackLandingPageViewed(amount, publicId, senderId, ClaimFlowType.receive);
  };

  const fireCtaTappedEvents = (claimType: ClaimType) =>
    trackCTATapped(
      'P2P Request Payment',
      'Get $',
      'P2P Request Payment Landing Page',
      'p2p_request_payment_get_money_button',
      publicId,
      claimType
    );

  return useCreateLandingPageHook(
    fireCtaTappedEvents,
    fireLandingPageViewedEvents
  );
};

export default useReceiveFromAnyoneLandingPage;
